import { render, staticRenderFns } from "./laboratoryUnits.vue?vue&type=template&id=3c4da1ac"
import script from "./laboratoryUnits.vue?vue&type=script&lang=js"
export * from "./laboratoryUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports